import React from 'react'
import PropTypes from 'prop-types'
import RangePair from './RangePair'
import BooleanFilter from './BooleanFilter'
import Collection from './Collection'

import CarDriveWheels from './CarDriveWheels'
import CarColors from './CarColors'
import CarChassis from './CarChassis'

const ComponentIdMap = {
  cars_drive_wheels: CarDriveWheels,
  car_chassis: CarChassis,
  car_colors: CarColors,
}

const ComponentsMap = {
  range_pair: RangePair,
  boolean: BooleanFilter,
  collection: Collection,
}

const FilterComponents = (props) => {
  const { type, id } = props

  const Component = ComponentIdMap[id] || ComponentsMap[type]

  if (Component) {
    return <Component {...props} />
  }

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('no component found for', type, props.id)
  }

  return null
}

export default FilterComponents

FilterComponents.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}
